import { Controller } from 'react-hook-form'
import { MultiCascader } from 'rsuite'
import classNames from 'classnames'

export default function EditMultiCascaderCell({
  id,
  rowData,
  dataKey,
  items = [],
  disabledItemValues = [],
  uncheckableItemValues = [],
  error,
  register,
  control,
  isEdit,
  placeholder,
  rules,
  onChangeCell = () => {},
  menuWidth = 220,
  menuHeight = 200,
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id

  const itemHeight = 36
  const maxHeight = 320

  return (
    <span {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <>
          <Controller
            name={_id}
            control={control}
            defaultValue={rowData[dataKey]}
            rules={rules}
            render={(props) => {
              return (
                <MultiCascader
                  className={classNames(error && 'is-error')}
                  size="lg"
                  block
                  menuHeight={menuHeight}
                  menuWidth={menuWidth}
                  //menuHeight={Math.min(items.length * itemHeight, maxHeight)}
                  //menuAutoWidth
                  data={items}
                  disabledItemValues={disabledItemValues}
                  uncheckableItemValues={uncheckableItemValues}
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    onChangeCell(value)
                  }}
                  placeholder={placeholder}
                  renderValue={(value, selectedItems) => {
                    return <span>{selectedItems.map((item) => item.label).join(' , ')}</span>
                  }}
                />
              )
            }}
          />
        </>
      ) : (
        <span>{rowData[dataKey]}</span>
      )}
    </span>
  )
}
